import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { GoBackAction, GoForwardAction, NavigateAction } from './router.actions';

@Injectable()
export class RouterEffects {
  navigate$; // Объявляем свойства как поля
  navigateBack$;
  navigateForward$;

  constructor(
    private actions: Actions,
    private router: Router,
    private location: Location
  ) {


    // Инициализируем эффекты в конструкторе
    this.navigate$ = createEffect(
      () => {
        return this.actions.pipe(
          ofType(NavigateAction),
          map(action => action.payload),
          tap(routeInfo => {
            const { path, query, extras } = routeInfo;
            this.router.navigate(path, { queryParams: query, ...extras });
          })
        );
      },
      { dispatch: false }
    );

    this.navigateBack$ = createEffect(
      () => this.actions.pipe(
        ofType(GoBackAction),
        tap(() => {
          this.location.back();
        })
      ),
      { dispatch: false }
    );

    this.navigateForward$ = createEffect(
      () => this.actions.pipe(
        ofType(GoForwardAction),
        tap(() => {
          this.location.forward();
        })
      ),
      { dispatch: false }
    );
  }
}